/* oxlint-disable lingui/no-unlocalized-strings */
// Don't translate for single language organizations
import { Text } from "@medoma/components/Text/Text";
import styles from "../guideTemplate.module.scss";

export const GuideTemplateSlsoHuddinge = () => (
  <>
    <Text element="p">
      Hej och välkommen till oss på ASIH! Avancerad sjukvård i hemmet i Region
      Stockholms egen regi.
    </Text>
    <Text element="p">
      ASIH är en form av vård som du kan välja när alternativet annars är
      sjukhusvård. Vården hos oss är kostnadsfri och vår verksamhet är
      tillgänglig dygnet runt. Vi finns i hela Stockholm och du kommer till oss
      via remiss från din läkare. Det här kan vi hjälpa dig med:
    </Text>
    <ul className={styles.bulletList}>
      <li>
        <Text element="span">
          ASIH kan utföra de flesta vårdinsatser som vanligtvis görs på en
          sjukhusavdelning. Exempelvis ge smärtlindring och dropp, sköta
          medicinsk utrustning, genomföra blodtransfusion och erbjuda stödjande
          samtalskontakt.
        </Text>
      </li>
      <li>
        <Text element="span">
          Palliativ vård med högspecialiserad och individanpassad
          symtomlindring.
        </Text>
      </li>
      <li>
        <Text element="span">
          Familjefokuserade samtal till patienter med barn som närstående.
        </Text>
      </li>
    </ul>
    <Text element="p">
      Vi samverkar med andra vårdenheter, behandlande specialistkliniker,
      kommunens biståndshandläggare och hemtjänst. Hos oss arbetar läkare,
      sjuksköterskor, undersköterskor, sjukgymnaster, arbetsterapeuter,
      kuratorer och dietister.
    </Text>
  </>
);
